import React, { useEffect, useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { IconWarning } from '../../../../../assets/icons/icon-warning';
import { EmptyStateBox } from '../../../../../components';
import ArrowButton from '../../../../../components/arrow-button';
import { ChannelTypeInternal } from '../../../../../data-access/gql-types/graphql';
import { ROUTES } from '../../../../../routes/routes';
import { ChannelIcon } from '../../../components/channel/icon';
import { useDevicesAndChannelsContext } from '../../../context/devices-and-channels';
import { ChannelType } from '../../../types';

type Params = {
  deviceId: string;
  channelId?: string;
};

const DeviceChannels: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation('channel-list');
  const { deviceId } = useParams<Params>();
  const { channelList } = useDevicesAndChannelsContext();
  const [channelListFiltered, setChannelListFiltered] = useState<ChannelType[]>([]);

  useEffect(() => {
    setChannelListFiltered(
      channelList.filter(
        (channel) => channel && channel.deviceId === deviceId && channel.data.type !== ChannelTypeInternal.GenericInput,
      ) as ChannelType[],
    );
  }, [channelList]);

  const deviceTabs = React.useMemo(
    () =>
      channelListFiltered.map((channel) => {
        if (channel) {
          return {
            id: channel.id,
            title: channel.alias,
            type: channel.data.type,
            deviceId: channel.deviceId,
            iconName: channel.iconName,
          };
        }
      }),
    [channelListFiltered],
  );

  const renderChannels = useMemo(() => {
    if (channelListFiltered.length === 0) {
      return <EmptyStateBox header={t('channels')} content={t('channelsEmptyState.content')} icon={<IconWarning />} />;
    }

    return channelListFiltered.map((channel) => {
      if (channel) {
        return (
          <ArrowButton
            key={channel.id}
            title={channel.alias}
            icon={<ChannelIcon channel={channel} />}
            onClick={() => navigate(`${ROUTES.ChannelConfiguration(channel.data.type, channel.id)}?redirect=true`)}
            className="m-b-24 big-radius"
          />
        );
      }
    });
  }, [deviceTabs, channelListFiltered]);

  return <section className="driver-settings__devices grid-list-24 m-t-32">{renderChannels}</section>;
};

export default DeviceChannels;
